import {useCallback, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {userApi} from 'api';
import {Button} from 'components';
import {DESKTOP_PAYMENT_SUCCESS_BANNER_PATH, MOBILE_PAYMENT_SUCCESS_BANNER_PATH} from 'constants/images';
import {useApiData} from 'hooks';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.CHARGEBEE_PAYMENT_SUCCESS;

type Props = {
    action: () => void;
};

export const PaymentSuccessStep: React.FC<Props> = ({action}) => {
    const {t} = useTranslation();

    const handleTokenUpdate = useCallback((data) => {
        userAuthUtils.setAuthData(data);
    }, []);

    const {send: refreshAuth} = useApiData(userApi.refreshAuthOnAccountActivation, {
        onSuccess: handleTokenUpdate
    });

    useEffect(() => {
        refreshAuth();
    }, [refreshAuth]);

    return (
        <div className='tw-text-center'>
            {t(T_KEYS.LABEL)}
            <img
                src={MOBILE_PAYMENT_SUCCESS_BANNER_PATH}
                className='sm:tw-hidden tw-mx-auto tw-mt-8 tw-max-w-64'
                alt={t(T_KEYS.BANNER_ALT)}
            />
            <img
                src={DESKTOP_PAYMENT_SUCCESS_BANNER_PATH}
                className='-sm:tw-hidden tw-mx-auto tw-mt-8 tw-max-h-64'
                alt={t(T_KEYS.BANNER_ALT)}
            />
            <Button
                type='submit'
                width='large'
                height='large'
                color='primary'
                fontSize='large'
                fontStyle='secondary'
                className='tw-mt-12'
                rounded
                onClick={action}
            >
                {t(T_KEYS.START_JOURNEY)}
            </Button>
        </div>
    );
};